module.exports = "img.float_text_left {\n    float: right;\n    clear: none;\n    margin: 15px;\n  }\n  span.float_text_right p {\n    width: 65%;\n    height: auto;\n    float: right;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.css
// module id = ./src/app/about/about.component.css
// module chunks = main